// Define styles for the main container of the sidebar
export const styles = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  drawerContainer: {
    width: '320px',
    zIndex: 9999,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: '320px',
      boxSizing: 'border-box',
      backgroundColor: '#F4F4F8',
      boxShadow: '2px 0px 10px 0px #82828240',
    },
    '& .MuiBackdrop-root.MuiModal-backdrop': {
      background: 'rgba(0,0,0,0.1)',
    },
  },
};
